import { render, staticRenderFns } from "./PanelSellos.vue?vue&type=template&id=d69ce81a&scoped=true&"
import script from "./PanelSellos.vue?vue&type=script&lang=js&"
export * from "./PanelSellos.vue?vue&type=script&lang=js&"
import style0 from "./PanelSellos.vue?vue&type=style&index=0&id=d69ce81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69ce81a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBreadcrumbs,VContainer,VFlex,VIcon,VLayout,VTab,VTabItem,VTabs,VTabsSlider})
